import { ApiService } from "./api.service";
export default class NotesService extends ApiService {
  namespace = "notes";
  icon = "WindowWithText";
  name = "Notes";
  favicon = "DocumentWithText";
  action = "action";
  Width = 900;
  label = "good";
  constructor() {
    super("rich-texts");
  }
}
